import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  Snackbar,
  FormControlLabel,
  Switch,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Newsletter = () => {
  const theme = useTheme();
  const [newsletter, setNewsletter] = useState({
    subject: '',
    content: '',
    isHtml: false,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    setNewsletter(prev => ({
      ...prev,
      [name]: name === 'isHtml' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // TODO: Implement API call to send newsletter
      setSnackbar({
        open: true,
        message: 'Newsletter sent successfully!',
        severity: 'success'
      });
      setNewsletter({
        subject: '',
        content: '',
        isHtml: false,
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: 'Failed to send newsletter. Please try again.',
        severity: 'error'
      });
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Newsletter
      </Typography>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 800,
          mx: 'auto',
          bgcolor: theme.palette.background.paper,
        }}
      >
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Email Subject"
            name="subject"
            value={newsletter.subject}
            onChange={handleChange}
            required
            margin="normal"
            variant="outlined"
          />
          <TextField
            fullWidth
            label="Email Content"
            name="content"
            value={newsletter.content}
            onChange={handleChange}
            required
            multiline
            rows={8}
            margin="normal"
            variant="outlined"
            helperText={newsletter.isHtml ? "HTML content is allowed" : "Plain text only"}
          />
          <FormControlLabel
            control={
              <Switch
                checked={newsletter.isHtml}
                onChange={handleChange}
                name="isHtml"
                color="primary"
              />
            }
            label="Enable HTML Content"
          />
          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="large"
              sx={{ minWidth: 200 }}
            >
              Send Newsletter
            </Button>
          </Box>
        </form>
      </Paper>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Newsletter; 